import { Injectable, isDevMode, signal } from "@angular/core";
import { events_endpoint } from "@api";
import { ApiGeneralService } from "@api/General/api-general.service";
import { environment } from "src/environments/environment";

export interface Time {
  days: number;
  hours: string;
  minutes: string;
  seconds: string;
  timer: number;
}

@Injectable({
  providedIn: "root",
})
export class CountdownService {
  interval: any;
  public time = signal<Time>({
    days: 0,
    hours: "00",
    minutes: "00",
    seconds: "00",
    timer: 1,
  });

  timer = 1;

  date = new Date();

  hit = 0;

  constructor(private api: ApiGeneralService) {}

  resetCountdown() {
    this.time.update(
      (x) =>
        (x = {
          days: 0,
          hours: "00",
          minutes: "00",
          seconds: "00",
          timer: 0,
        })
    );
  }

  getDataCountdown(): Promise<any> {
    this.hit++;

    if (this.hit > 1) {
      return Promise.resolve(this.timer);
    }

    // if (environment.liveMacro) {
    //   this.timer = -1;
    //   return Promise.resolve(this.timer);
    // }

    return this.api.getAll({}, events_endpoint.countdown).then((res: any) => {
      if (res) {
        if (!this.interval && res.countdown > 0) {
          this.startCountdown(res.countdown);
          // return res.countdown;
        } else {
          this.reset();
        }
        return res.countdown;
      }
    });
  }

  reset() {
    this.timer = -1;
    this.time.update(
      (x) =>
        (x = {
          days: 0,
          hours: "00",
          minutes: "00",
          seconds: "00",
          timer: 0,
        })
    );
  }

  startCountdown(seconds: number) {
    this.interval = setInterval(() => {
      let distance = seconds * 1000;
      seconds--;

      if (distance < 0) {
        this.timer = -1;
        clearInterval(this.interval);
      } else {
        // Konversi jarak waktu menjadi hari, jam, menit, dan detik
        this.time.update(
          (x) =>
            (x = {
              days: Math.floor(distance / (1000 * 60 * 60 * 24)),
              hours: (
                "0" +
                Math.floor(
                  (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
                )
              ).slice(-2),
              minutes: (
                "0" + Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
              ).slice(-2),
              seconds: (
                "0" + Math.floor((distance % (1000 * 60)) / 1000)
              ).slice(-2),
              timer: seconds,
            })
        );

        this.timer = seconds;

        if (isDevMode()) {
          // console.log(seconds);
        }
      }
    }, 1000);
  }
}
